import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {

  constructor(http:HttpClient) {

    return

    var log = console.log;
    var warn = console.warn;
    var error = console.error;

    window.console.warn = function (s) {
      http.post('https://xpert.i-expert.it/api/log.php',{level:1, message:s}).subscribe()
      warn(s)
      //oldLogger.warn(s)
    };

    window.console.log = function (s) {
      http.post('https://xpert.i-expert.it/api/log.php',{level:1, message:s}).subscribe()
      log(s)
      //oldLogger.log(s)
    };

    window.console.error = function (s) {
      http.post('https://xpert.i-expert.it/api/log.php',{level:1, message:s}).subscribe()
      error(s)
      //oldLogger.error(s)
    };

    window.console.clear = function(){return 'replaced'}

   }
}
